<template>
  <section
      :id="!!id.length ? id : null"
      class="request-interest push-v--desktop--large push-v--tablet--large push-v--mobile--large"
  >
    <request-interest class="request-interest__shape" />

    <div class="request-interest__content">
      <div class="row">
        <div class="col-10 offset-1 col-md-7 col-lg-5 col-lg">
          <div v-if="!submitted && !errored" class="request-interest__form">
            <h2 class="h4 request-interest__title">{{ title }}</h2>
            <p v-if="subtitle" class="request-interest__sub-title">{{ subtitle }}</p>
            <div v-if="intro" class="request-interest__intro" v-html="intro" />
            <form :action="generatedAction" class="field--dark" method="post" role="form" @submit.prevent="submit">
              <div class="request-interest__fields">
                <input-text
                    ref="firstName"
                    v-model="firstName"
                    :label="firstNameFieldLabel"
                    error-message="Please enter your first name"
                    autocomplete-value="given-name"
                    validate="required|alpha_spaces"
                    class="request-interest__field"
                    name="FNAME"
                    type="text"
                    @input="validate"
                />

                <input-text
                    ref="lastName"
                    v-model="lastName"
                    autocomplete-value="family-name"
                    :label="lastNameFieldLabel"
                    error-message="Please enter your last name"
                    validate="required|alpha_spaces"
                    class="request-interest__field"
                    name="LNAME"
                    type="text"
                    @input="validate"
                />

                <input-text
                    ref="email"
                    v-model="email"
                    :label="emailFieldLabel"
                    autocomplete-value="email"
                    error-message="Please enter your email address in format: yourname@example.com"
                    validate="required|email"
                    name="EMAIL"
                    class="request-interest__field"
                    type="email"
                    @input="validate"
                />

                <input-check
                    ref="confirmed"
                    v-model="confirmed"
                    :label="termsAndConditionsLabel"
                    class="request-interest__field"
                    name="CONFIRMED"
                    @input="validate"
                />

                <div>
                  <button :disabled="isDisabled" class="request-interest__button btn--dark-green" type="submit">
                    {{ submitButtonText }}<Arrow class="btn--arrow__icon btn--arrow__icon--orange" />
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div v-if="submitted || errored" class="request-interest__wrap">
            <div v-if="submitted">
              <h3 class="request-interest__success">{{ thankYouTitle }}</h3>
              <div v-if="thankYouBody" v-html="thankYouBody" />
            </div>
            <div v-if="errored">
              <div v-html="submissionError" />
            </div>
          </div>
        </div>
        <KenticoResponsiveImage :src="collectiveCharacters" :alt="title" class="request-interest__background" :sizes="imageSizes" />
      </div>
    </div>
  </section>
</template>

<script>
import jsonp from 'jsonp';
import queryString from 'query-string';
import getStatic from '~/utils/get-static';
import InputText from '~/components/elements/InputText';
import InputCheck from '~/components/elements/InputCheck';
import RequestInterest from '~/assets/icons/request-interest.svg?inline';
import { BREAKPOINTS, BREAKPOINT_MD, BREAKPOINT_LG } from '~/utils/constants';

export default {
  components: {
    InputText,
    InputCheck,
    RequestInterest,
  },
  props: {
    collectiveCharacters: { type: String, default: getStatic('/images/content/request-interest/lobby.svg') },
    id: { type: String, default: 'register-form' },
    formAction: { type: String, default: '//thecollective.us10.list-manage.com/subscribe/post-json?append' },
    userId: { type: String, required: true, default: '' },
    listId: { type: String, required: true, default: '' },
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
    intro: { type: String, default: '' },
    firstNameFieldLabel: { type: String, required: true, default: '' },
    lastNameFieldLabel: { type: String, required: true, default: '' },
    emailFieldLabel: { type: String, required: true, default: '' },
    termsAndConditionsLabel: { type: String, required: true, default: '' },
    submitButtonText: { type: String, required: true, default: '' },
    thankYouTitle: { type: String, required: true, default: '' },
    thankYouBody: { type: String, default: '' },
    submissionError: { type: String, required: true, default: '' },
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      confirmed: null,
      submitted: false,
      errored: false,
      isDisabled: true,
      imageSizes: {
        default: [1000, 638],
        sizes: [
          { breakpoint: BREAKPOINTS[BREAKPOINT_MD], width: 854, height: 542 },
          { breakpoint: BREAKPOINTS[BREAKPOINT_LG], width: 1000, height: 638 },
        ],
      },
    };
  },
  computed: {
    generatedAction() {
      return `${this.formAction}&u=${this.userId}&id=${this.listId}`;
    },
    confirmClass() {
      return {
        error: false, // ! this.validField('request-interest-confirm'),
      };
    },
  },
  methods: {
    validate() {
      if (
        this.$refs.firstName.isValid() &&
        this.$refs.lastName.isValid() &&
        this.$refs.email.isValid() &&
        this.$refs.confirmed.isChecked()
      ) {
        this.isDisabled = false;
        return true;
      } else {
        this.isDisabled = true;
        return false;
      }
    },
    clearForms() {
      this.confirmed = null;
      this.firstName = '';
      this.lastName = '';
      this.email = '';
    },
    async submit() {
      if (this.validate()) {
        const query = queryString.stringify({
          FNAME: this.firstName,
          LNAME: this.lastName,
          EMAIL: this.email,
        });
        const url = `${this.generatedAction}&${query}`;

        jsonp(
            url,
            {
              param: 'c',
            },
            (err) => {
              if (err) {
                this.errored = true;
                return;
              }

              this.submitted = true;

              this.clearForms();
            }
        );
      }
    },
  },
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/modules/_request-interest.scss';
</style>
